import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { APP } from './app.config';
import { GuestHashService } from './guest-hash.service';
import { UserStateService } from './user-state.service';

@Injectable({
  providedIn: 'root',
})
export class MyBookingsService {
  user;
  orga;

  constructor(
    private guestService: GuestHashService,
    private http: HttpClient,
    private userStateService: UserStateService
  ) {
    this.user = this.guestService.getUser();
  }

  async getUserBookings(activeOrganisation) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'x-organisation-id': activeOrganisation._id,
      }),
    };

    return this.http
      .get(
        APP.baseurl + '/reservationItem/userBookings/' + this.user.id,
        httpOptions
      )
      .toPromise();
  }

  deleteBooking(id, date, activeOrganisation) {

    // http://localhost:3000/reservationItem/5f8eb38141d527c4209ac4f1/2020-10-12
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'x-organisation-id': activeOrganisation,
      }),
      body: {
        // make sure newest user is used. this.user.id can still hold the old value after a sync
        userId: JSON.parse(localStorage.getItem('user') || '{}').id,
      },
    };

    return this.http
      .delete(APP.baseurl + '/reservationItem/' + id  + '/' + date, httpOptions)
      .toPromise();
  }

  adminDeleteBooking(id, username, date, activeOrganisation) {

    // http://localhost:3000/reservationItem/5f8eb38141d527c4209ac4f1/2020-10-12
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'x-organisation-id': activeOrganisation,
      }),
      body: {
        username: username,
      },
    };



    return this.http
      .delete(APP.baseurl + '/reservationItem/admin/' + id  + '/' + date, httpOptions)
      .toPromise();
  }

  /**
   * Delete booking using recovery code (for anonymous users)
   */
  deleteBookingWithRecoveryCode(id, date, activeOrganisation, recoveryCode) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'x-organisation-id': activeOrganisation,
      }),
      body: {
        recoveryCode: recoveryCode,
      },
    };

    return this.http
      .delete(APP.baseurl + '/reservationItem/' + id  + '/' + date, httpOptions)
      .toPromise();
  }

   /**
    * Delete booking using authentication (for authenticated users)
    */
   deleteBookingWithAuth(id, date, activeOrganisation) {
     const httpOptions = {
       headers: new HttpHeaders({
         'Content-Type': 'application/json',
         'x-organisation-id': activeOrganisation,
       }),
       body: {},
     };

     return this.http
       .delete(APP.baseurl + '/reservationItem/' + id  + '/' + date, httpOptions)
       .toPromise();
   }

   /**
    * Migrate bookings from anonymous user to authenticated user
    * Called when a guest user logs in with Cidaas
    * @param oldUserId - The old anonymous user ID
    * @param newUserId - The new authenticated user ID
    * @param authToken - The authentication token (required for authorization)
    * @param organisationId - The organisation ID (required in header)
    */
   async migrateBookings(oldUserId: string, newUserId: string, authToken: string, organisationId: string) {
     try {
       const httpOptions = {
         headers: new HttpHeaders({
           'Content-Type': 'application/json',
           'Authorization': `Bearer ${authToken}`,
           'x-organisation-id': organisationId,
         }),
       };

       const response = await this.http
         .post(
           APP.baseurl + '/reservationItem/migrate-bookings',
           {
             oldUserId: oldUserId,
             newUserId: newUserId,
           },
           httpOptions
         )
         .toPromise();

       return response;
     } catch (error) {
       console.error('Error migrating bookings:', error);
       throw error;
     }
   }
}
